/*

{
  identifier: {
    pk: PAGE#{pageId}
    sk: STATE#{state}#PAGE#{pageId}#DATA
  }
  pageId: createdAt
  pageName: string
  pageType: | image, text, pdf, video, videoLink |
  pageContent: |
    imageFilePath,
    textContent, // Stringified rich text data if
    pdfFilePath,
    videoFilePath,
    videoUrl,
  |,
  ownerId: | userId, teamId, eocId, orgId |
  ownderType: | user, team, eoc, org |
}

*/

const { DataTableBase } = require('./base.class');
const { identifiers } = require('../datastructComponents');
const Joi = require('joi');
const { STATES, LIBRARY_TYPES, PAGE_TYPES } = require('@bcm/constants');

const schema = {
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  pageId: Joi.string().required(),
  pageName: Joi.string().required(),
  pageType: Joi.string().valid( ...Object.keys(PAGE_TYPES) ).required(),
  pageText: Joi.string().optional(),
  pageObject: Joi.object().optional(),
  pageObjects: Joi.array().items( Joi.object().required() ).optional(),
  ownerType: Joi.string().valid( ...Object.keys(LIBRARY_TYPES) ).required(),
  ownerId: Joi.string().required(),
};

class Page extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.page.buildPk(obj.pageId),
      identifiers.page.buildSk(obj.state, obj.pageId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Page = Page;
exports.pageSchema = schema;
